import {CounsellingPlanDraft, CounsellingPlanLine} from "@/medication-checkup/interfaces/counselling-plan";
import TreatmentLineDosageService from "@/medication-checkup/services/TreatmentLineDosageService";

/**
 * The lines of the posology plan as the scene, its card and the patient full
 * screen read them, drafts included.
 */
const CounsellingPlanService = () => {
    return {
        /**
         * The key of a line: its anchor.
         */
        key(line: CounsellingPlanLine): string {
            return line.intervention_id !== null
                ? `intervention:${line.intervention_id}`
                : `decision:${line.doctor_decision_id}`;
        },

        /**
         * The posology of a line in words: the draft entered while live,
         * else the one that stands.
         */
        posology(line: CounsellingPlanLine, draft: CounsellingPlanDraft | null | undefined): string | null {
            if (draft?.dosage) {
                return TreatmentLineDosageService.describe(draft.dosage.data, draft.dosage.comment);
            }

            return line.posology;
        },

        /**
         * The advice of a line: the one typed while live, else the recorded
         * one.
         */
        advice(line: CounsellingPlanLine, draft: CounsellingPlanDraft | null | undefined): string | null {
            const typed = draft?.advice.trim();

            return typed === undefined ? line.advice : (typed || null);
        },
    };
};

export default CounsellingPlanService();
